import React from 'react'
import logo from '../logo.svg'
import '../template/master.css'

const Header = (props) =>{
  return(
    <div className="bbx-header">
      <img src={logo} class="logo" />
      </div>
  )
}
export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js